<template>
  <ul class="list-box">
    <li class="list-item" v-for="item in listData" :key="item.wId">
      <a :href="item.url">
        <div class="title"><a :href="item.url" v-html="item.title"></a></div>
        <div class="cont" v-html="item.content"></div>
        <div class="tag-box">
          <div class="tag-box-item">
            <div class="tag-item">{{ item.areaName }}</div>
            <div class="tag-item tag-item-or">{{ item.progstr }}</div>
          </div>
          <div class="tag-time"><i class="iconfont icon-shijian"></i> {{ item.inputtime }}</div>
        </div>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: "List",
  components: {},
  data() {
    return {
      progObj: [
        {
          id: 0,
          progText: "招标公告",
        },
        {
          id: 1,
          progText: "招标预告",
        },
        {
          id: 2,
          progText: "招标变更",
        },
        {
          id: 3,
          progText: "中标结果",
        },
      ],
    };
  },
  computed: {
    listObj() {
      return this.$store.getters["wapGjxx/listObj"];
    },
    listData() {
      return this.listObj.bodyData.map((item) => {
        let textData = this.progObj.find((itm) => itm.id === item.progid);
        if (!item.progstr) {
          item.progstr = textData.progText;
        }
        const URL = item.url.replace("www.qianlima.com", "wap.qianlima.com");
        return {
          ...item,
          url: URL,
        };
      });
    },
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss">
.list-box {
  width: 100%;
  .list-item {
    width: 100%;
    padding: 16px 10px 10px;
    margin: 10px 0;
    border-radius: 5px;
    background-color: #fff;
    .title {
      width: 100%;
      font-size: 16px;
      margin-bottom: 5px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      padding-bottom: 3px;
    }
    .cont {
      width: 100%;
      overflow: hidden;
      padding-top: 8px;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      color: #666;
      margin-bottom: 8px;
      border-top: 1px solid #d7d7d7;
      font-size: 14px;
    }
    .tag-box {
      width: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      justify-content: space-between;
      .tag-box-item {
        display: flex;
        align-items: center;
      }
      .tag-item {
        font-size: 13px;
        border-radius: 3px;
        padding: 4px 12px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 550;
        color: #1687ff;
        background: #eff6ff;
        margin-right: 8px;
        line-height: 16px;
        &.tag-item-or {
          color: #ff643d;
          background: #fff2ee;
        }
      }
      .tag-time {
        color: #666;
        i {
          font-size: 13px;
        }
      }
    }
  }
}
</style>
